import { message, type FormInstance } from 'ant-design-vue'
import { ref } from 'vue'

export const handleFormError = (err: any, msg = '操作失败') => {
  err.errorFields ? message.error(err.errorFields[0].errors[0]) : message.error(msg)
}

export const useFormExpose = expose => {
  const formRef = ref<FormInstance>()
  const bindMethod =
    (methodName: keyof FormInstance) =>
    (...args: any[]) =>
      formRef.value?.[methodName]?.(...args)

  expose({
    clearValidate: bindMethod('clearValidate'),
    resetFields: bindMethod('resetFields'),
    scrollToField: bindMethod('scrollToField'),
    validate: bindMethod('validate'),
    validateFields: bindMethod('validateFields')
  })
  return {
    formRef
  }
}
